import util from '../../lib/util';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import TemplateTask from '../../entities/templateTask';
import CaseTypeStage from '../../entities/caseTypeStage';
import Task from '../../entities/task';

/*
 * Delete/nullify anywhere this templateTask is used in other entities
 *
 * @param {TemplateTask} templateTask
 */
export function deleteTemplateTask(templateTask: TemplateTask, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = templateTask.id;
    }
    /* Simple delete usages */
        
    store.getState().caseTypeStages
        .getMappingFor('templateTaskId', templateTask.id)
        .filter(caseTypeStageTemp => caseTypeStageTemp.status !== 'D')
        .forEach(caseTypeStageTemp => {
            const _caseTypeStage = caseTypeStageTemp.clone();
            _caseTypeStage.status =  'U';
            _caseTypeStage.addedOn = newHRTimestamp();
            _caseTypeStage.importSource = targetImportSource;
            _caseTypeStage.importId = mergeId;

            _caseTypeStage.templateTaskIds = _caseTypeStage.templateTaskIds?.filter(id => id !== templateTask.id) || [];
            store.dispatch(Actions.CaseTypeStageActions.saveCaseTypeStageQueue(_caseTypeStage));
        });

    store.getState().tasks
        .getMappingFor('templateTaskId', templateTask.id)
        .filter(taskTemp => taskTemp.status !== 'D')
        .forEach(taskTemp => {
            const _task = taskTemp.clone();
            _task.status =  'U';
            _task.addedOn = newHRTimestamp();
            _task.addedBy = getCurrentUserId();
            _task.importSource = targetImportSource;
            _task.importId = mergeId;

            _task.fromTemplateId = null;
            store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
        });

    /* Remove the actual templateTask */
    templateTask.status = 'D';
    templateTask.addedOn = newHRTimestamp();
    templateTask.addedBy = getCurrentUserId();
    templateTask.importSource = targetImportSource;
    templateTask.importId = mergeId;
    store.dispatch(Actions.TemplateTaskActions.removeTemplateTaskQueue(templateTask));
    
}

/*
 * Replace anywhere this templateTask is used in other entities.
 *
 * @param {TemplateTask} templateTask
 * @param {TemplateTask} replaceWith
 * @return {TemplateTask} - TemplateTask will have refs stripped away
 */
export function replaceTemplateTask(templateTask: TemplateTask, replaceWith: TemplateTask, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = templateTask.id;
    }
    /* Simple replace usages */
        
    store.getState().caseTypeStages
        .getMappingFor('templateTaskId', templateTask.id)
        .filter(caseTypeStageTemp => caseTypeStageTemp.status !== 'D')
        .forEach(caseTypeStageTemp => {
            const _caseTypeStage = caseTypeStageTemp.clone();
            _caseTypeStage.status =  'U';
            _caseTypeStage.addedOn = newHRTimestamp();
            _caseTypeStage.importSource = targetImportSource;
            _caseTypeStage.importId = mergeId;

            _caseTypeStage.templateTaskIds = _caseTypeStage.templateTaskIds?.map(id => (id === templateTask.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.CaseTypeStageActions.saveCaseTypeStageQueue(_caseTypeStage));
        });

    store.getState().tasks
        .getMappingFor('templateTaskId', templateTask.id)
        .filter(taskTemp => taskTemp.status !== 'D')
        .forEach(taskTemp => {
            const _task = taskTemp.clone();
            _task.status =  'U';
            _task.addedOn = newHRTimestamp();
            _task.addedBy = getCurrentUserId();
            _task.importSource = targetImportSource;
            _task.importId = mergeId;

            _task.fromTemplateId = replaceWith.id;
            store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
        });

    return templateTask;
}

/*
 * Determine the impact of deleting this templateTask from other entities
 *
 * @param {TemplateTask} templateTask
 * @return {Array.<{count: number, entity: string}>} - a list of impacted entities, along with a count of impacted entities
 */
export function deleteImpactTemplateTask(templateTask: TemplateTask) {
    const impacts: string[] = [];
    const state = store.getState();
    
    /* Simple delete usages */
        
    const caseTypeStageTemplateTaskIdsImpact = state.caseTypeStages
          .getMappingFor('templateTaskId', templateTask.id)
          .filter(caseTypeStage => caseTypeStage.status !== 'D');

    caseTypeStageTemplateTaskIdsImpact.forEach(() => impacts.push('caseTypeStages'));

    const taskFromTemplateIdImpact = state.tasks
          .getMappingFor('templateTaskId', templateTask.id)
          .filter(task => task.status !== 'D');

    taskFromTemplateIdImpact.forEach(() => impacts.push('tasks'));

    return util.countDistinct(impacts);
}